var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({ref:"input",attrs:{"value":_vm.formattedValue,"persistent-hint":"","readonly":""},on:{"keydown":_vm.checkValue},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(value,key){return {key:key,fn:function(){return [_vm._t(key)]},proxy:true}})],null,true)},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }